/**
 * Textes de la zone « Parc » (clés préfixées `fleet.`), fusionnés dans les dictionnaires par i18n/locales/*.ts.
 * Les trois langues doivent fournir exactement les mêmes clés et variables (vérifié par les tests i18n).
 */
export const fleetFr = {
  'fleet.title': 'Parc d\'appareils',
  'fleet.description': 'Appareils de l\'organisation, état en ligne, groupes, inventaire et alertes.',
  'fleet.tabs': 'Sections du parc',
  'fleet.tab.devices': 'Appareils',
  'fleet.tab.groups': 'Groupes',
  'fleet.tab.alerts': 'Alertes',
  'fleet.cancel': 'Annuler',
  'fleet.save': 'Enregistrer',
  'fleet.now': 'À l\'instant',
  'fleet.toast.error': 'L\'action a échoué. Réessayez.',
  'fleet.summary': '{online} en ligne sur {total} appareils',
  'fleet.search': 'Rechercher un appareil, un ID, une IP ou une étiquette',
  'fleet.filters': 'Filtres',
  'fleet.table': 'Liste des appareils',
  'fleet.filter.status': 'Statut',
  'fleet.filter.allStatus': 'Tous',
  'fleet.filter.os': 'Système',
  'fleet.filter.allOs': 'Tous',
  'fleet.filter.group': 'Groupe',
  'fleet.filter.allGroups': 'Tous',
  'fleet.filter.tag': 'Étiquette',
  'fleet.filter.allTags': 'Toutes',
  'fleet.empty.title': 'Aucun appareil enrôlé',
  'fleet.empty.desc': 'Déployez l\'agent Siraj avec un jeton d\'enrôlement pour voir vos appareils ici.',
  'fleet.empty.filtered': 'Aucun appareil ne correspond',
  'fleet.empty.filteredDesc': 'Modifiez ou effacez les filtres pour élargir la recherche.',
  'fleet.col.name': 'Appareil',
  'fleet.col.status': 'Statut',
  'fleet.col.os': 'Système',
  'fleet.col.group': 'Groupe',
  'fleet.col.tags': 'Étiquettes',
  'fleet.col.agent': 'Agent',
  'fleet.col.lastSeen': 'Dernière activité',
  'fleet.col.alerts': 'Alertes',

  'fleet.os.windows': 'Windows',
  'fleet.os.macos': 'macOS',
  'fleet.os.linux': 'Linux',
  'fleet.os.android': 'Android',
  'fleet.os.ios': 'iOS',

  'fleet.bulk.toolbar': 'Actions groupées',
  'fleet.bulk.move': 'Déplacer vers un groupe',
  'fleet.bulk.tag': 'Étiqueter',
  'fleet.bulk.revoke': 'Révoquer',
  'fleet.bulk.clear': 'Désélectionner',
  'fleet.bulk.noGroup': 'Aucun groupe',
  'fleet.bulk.moveTitle': 'Déplacer {count} appareil(s)',
  'fleet.bulk.moveConfirm': 'Déplacer',
  'fleet.bulk.tagTitle': 'Étiqueter {count} appareil(s)',
  'fleet.bulk.tagMode': 'Opération',
  'fleet.bulk.tagAdd': 'Ajouter l\'étiquette',
  'fleet.bulk.tagRemove': 'Retirer l\'étiquette',
  'fleet.bulk.tagName': 'Nom de l\'étiquette',
  'fleet.bulk.tagConfirm': 'Appliquer',
  'fleet.bulk.revokeTitle': 'Révoquer {count} appareil(s) ?',
  'fleet.bulk.revokeDesc': 'Les appareils révoqués sont supprimés de l\'organisation : ils perdent tout accès et devront être enrôlés de nouveau. Cette action est journalisée.',
  'fleet.bulk.revokeConfirm': 'Révoquer',
  'fleet.bulk.done': '{count} appareil(s) mis à jour',
  'fleet.bulk.partial': '{ok} appareil(s) mis à jour, {failed} en échec',

  'fleet.groups.intro': 'Organisez les appareils en groupes imbriqués pour leur appliquer des politiques et des droits.',
  'fleet.groups.create': 'Nouveau groupe',
  'fleet.groups.tree': 'Arbre des groupes',
  'fleet.groups.empty': 'Aucun groupe',
  'fleet.groups.emptyDesc': 'Créez un premier groupe pour classer vos appareils.',
  'fleet.groups.devices': '{count} appareil(s)',
  'fleet.groups.view': 'Voir les appareils de {name}',
  'fleet.groups.addChild': 'Ajouter un sous-groupe à {name}',
  'fleet.groups.edit': 'Renommer ou déplacer {name}',
  'fleet.groups.delete': 'Supprimer {name}',
  'fleet.groups.collapse': 'Replier {name}',
  'fleet.groups.expand': 'Déplier {name}',
  'fleet.groups.createTitle': 'Nouveau groupe',
  'fleet.groups.editTitle': 'Modifier le groupe',
  'fleet.groups.name': 'Nom',
  'fleet.groups.nameRequired': 'Le nom est obligatoire.',
  'fleet.groups.description': 'Description',
  'fleet.groups.parent': 'Groupe parent',
  'fleet.groups.root': 'Aucun (racine)',
  'fleet.groups.created': 'Groupe créé',
  'fleet.groups.updated': 'Groupe modifié',
  'fleet.groups.deleted': 'Groupe supprimé',
  'fleet.groups.deleteTitle': 'Supprimer le groupe « {name} » ?',
  'fleet.groups.deleteDesc': '{devices} appareil(s) seront détachés du groupe et {children} sous-groupe(s) remonteront d\'un niveau. Les appareils ne sont pas supprimés.',
  'fleet.groups.deleteConfirm': 'Supprimer le groupe',

  'fleet.alerts.thresholds': 'Seuils d\'alerte',
  'fleet.alerts.thresholdsDesc': 'Une alerte est levée quand un appareil dépasse ces valeurs.',
  'fleet.alerts.disk': 'Disque utilisé (%)',
  'fleet.alerts.ram': 'Mémoire utilisée (%)',
  'fleet.alerts.offline': 'Hors ligne depuis (jours)',
  'fleet.alerts.pctHint': 'Alerte à partir de ce pourcentage.',
  'fleet.alerts.offlineHint': 'Alerte au-delà de ce nombre de jours.',
  'fleet.alerts.aiCredits': 'Alertes de crédits IA',
  'fleet.alerts.aiCreditsHint': 'Alerte à 80 % puis à 100 % de l\'allocation mensuelle de crédits IA (webhooks « ai_credits.alert » et journal d\'audit).',
  'fleet.alerts.range': 'Entrez un entier entre {min} et {max}.',
  'fleet.alerts.reset': 'Valeurs par défaut',
  'fleet.alerts.saved': 'Seuils enregistrés',
  'fleet.alerts.readOnly': 'Vous n\'avez pas le droit de modifier les seuils.',
  'fleet.alerts.table': 'Alertes ouvertes',
  'fleet.alerts.severity': 'Gravité',
  'fleet.alerts.device': 'Appareil',
  'fleet.alerts.kind': 'Type',
  'fleet.alerts.raised': 'Levée',
  'fleet.alerts.allKinds': 'Tous les types',
  'fleet.alerts.allSeverities': 'Toutes les gravités',
  'fleet.kind.offline': 'Hors ligne',
  'fleet.kind.disk': 'Disque',
  'fleet.kind.ram': 'Mémoire',
  'fleet.kind.agent_outdated': 'Agent obsolète',
  'fleet.kind.policy_denied': 'Accès refusé',

  'fleet.detail.back': 'Retour au parc',
  'fleet.detail.notFound': 'Appareil introuvable',
  'fleet.detail.notFoundDesc': 'Cet appareil n\'existe pas ou n\'appartient pas à cette organisation.',
  'fleet.detail.rename': 'Renommer',
  'fleet.detail.renameTitle': 'Renommer l\'appareil',
  'fleet.detail.renamed': 'Appareil renommé',
  'fleet.detail.updateAgent': 'Mettre à jour l\'agent',
  'fleet.detail.updateDone': 'Mise à jour de l\'agent demandée',
  'fleet.detail.revoke': 'Révoquer',
  'fleet.detail.revokeTitle': 'Révoquer « {name} » ?',
  'fleet.detail.revoked': 'Appareil révoqué',
  'fleet.detail.identity': 'Identité',
  'fleet.detail.sirajId': 'ID Siraj',
  'fleet.detail.hostname': 'Nom d\'hôte',
  'fleet.detail.ip': 'Adresse IP',
  'fleet.detail.enrolled': 'Enrôlé le',
  'fleet.detail.groupSaved': 'Groupe mis à jour',
  'fleet.detail.tagsSaved': 'Étiquettes mises à jour',
  'fleet.detail.noTags': 'Aucune étiquette',
  'fleet.detail.addTag': 'Ajouter une étiquette',
  'fleet.detail.addTagBtn': 'Ajouter',
  'fleet.detail.removeTag': 'Retirer l\'étiquette {tag}',
  'fleet.detail.system': 'Système et présence',
  'fleet.detail.live': 'Temps réel',
  'fleet.detail.channel': 'Canal de mise à jour',
  'fleet.detail.outdated': 'Mise à jour disponible',
  'fleet.detail.upToDate': 'À jour',
  'fleet.detail.inventory': 'Inventaire',
  'fleet.detail.inventoryDesc': 'Matériel, utilisation et logiciels installés',
  'fleet.detail.cpu': 'Processeur',
  'fleet.detail.ram': 'Mémoire',
  'fleet.detail.disk': 'Disque',
  'fleet.detail.gb': 'Go',
  'fleet.detail.antivirus': 'Antivirus',
  'fleet.detail.antivirus.protected': 'Protégé',
  'fleet.detail.antivirus.unprotected': 'Non protégé',
  'fleet.detail.antivirus.unknown': 'Inconnu',
  'fleet.detail.diskUsage': 'Utilisation du disque',
  'fleet.detail.ramUsage': 'Utilisation de la mémoire',
  'fleet.detail.threshold': 'seuil à {value} %',
  'fleet.detail.software': 'Logiciels installés',
  'fleet.detail.softwareName': 'Logiciel',
  'fleet.detail.softwareVersion': 'Version',
  'fleet.detail.alerts': 'Alertes de l\'appareil',
  'fleet.detail.alertsDesc': 'Seuils : disque {disk} %, mémoire {ram} %, hors ligne {days} j',
  'fleet.detail.noAlerts': 'Aucune alerte sur cet appareil',
  'fleet.detail.sessions': 'Historique des sessions',
  'fleet.detail.sessionsDesc': 'Dernières sessions à distance sur cet appareil',
  'fleet.detail.noSessions': 'Aucune session enregistrée',
  'fleet.detail.technician': 'Technicien',
  'fleet.detail.duration': 'Durée',
  'fleet.detail.mode': 'Mode',
  'fleet.session.mode.attended': 'Avec le client',
  'fleet.session.mode.unattended': 'Sans surveillance',
  'fleet.session.status.active': 'En cours',
  'fleet.session.status.ended': 'Terminée',
  'fleet.session.status.failed': 'Échec',
} as const;

type FleetKey = keyof typeof fleetFr;

export const fleetEn: Record<FleetKey, string> = {
  'fleet.title': 'Device fleet',
  'fleet.description': 'Organization devices, online status, groups, inventory and alerts.',
  'fleet.tabs': 'Fleet sections',
  'fleet.tab.devices': 'Devices',
  'fleet.tab.groups': 'Groups',
  'fleet.tab.alerts': 'Alerts',
  'fleet.cancel': 'Cancel',
  'fleet.save': 'Save',
  'fleet.now': 'Just now',
  'fleet.toast.error': 'The action failed. Try again.',
  'fleet.summary': '{online} online out of {total} devices',
  'fleet.search': 'Search a device, ID, IP or tag',
  'fleet.filters': 'Filters',
  'fleet.table': 'Device list',
  'fleet.filter.status': 'Status',
  'fleet.filter.allStatus': 'All',
  'fleet.filter.os': 'System',
  'fleet.filter.allOs': 'All',
  'fleet.filter.group': 'Group',
  'fleet.filter.allGroups': 'All',
  'fleet.filter.tag': 'Tag',
  'fleet.filter.allTags': 'All',
  'fleet.empty.title': 'No enrolled device',
  'fleet.empty.desc': 'Deploy the Siraj agent with an enrollment token to see your devices here.',
  'fleet.empty.filtered': 'No matching device',
  'fleet.empty.filteredDesc': 'Change or clear the filters to widen the search.',
  'fleet.col.name': 'Device',
  'fleet.col.status': 'Status',
  'fleet.col.os': 'System',
  'fleet.col.group': 'Group',
  'fleet.col.tags': 'Tags',
  'fleet.col.agent': 'Agent',
  'fleet.col.lastSeen': 'Last seen',
  'fleet.col.alerts': 'Alerts',

  'fleet.os.windows': 'Windows',
  'fleet.os.macos': 'macOS',
  'fleet.os.linux': 'Linux',
  'fleet.os.android': 'Android',
  'fleet.os.ios': 'iOS',

  'fleet.bulk.toolbar': 'Bulk actions',
  'fleet.bulk.move': 'Move to group',
  'fleet.bulk.tag': 'Tag',
  'fleet.bulk.revoke': 'Revoke',
  'fleet.bulk.clear': 'Clear selection',
  'fleet.bulk.noGroup': 'No group',
  'fleet.bulk.moveTitle': 'Move {count} device(s)',
  'fleet.bulk.moveConfirm': 'Move',
  'fleet.bulk.tagTitle': 'Tag {count} device(s)',
  'fleet.bulk.tagMode': 'Operation',
  'fleet.bulk.tagAdd': 'Add the tag',
  'fleet.bulk.tagRemove': 'Remove the tag',
  'fleet.bulk.tagName': 'Tag name',
  'fleet.bulk.tagConfirm': 'Apply',
  'fleet.bulk.revokeTitle': 'Revoke {count} device(s)?',
  'fleet.bulk.revokeDesc': 'Revoked devices are deleted from the organization: they lose all access and must be enrolled again. This action is logged.',
  'fleet.bulk.revokeConfirm': 'Revoke',
  'fleet.bulk.done': '{count} device(s) updated',
  'fleet.bulk.partial': '{ok} device(s) updated, {failed} failed',

  'fleet.groups.intro': 'Organize devices into nested groups to apply policies and permissions.',
  'fleet.groups.create': 'New group',
  'fleet.groups.tree': 'Group tree',
  'fleet.groups.empty': 'No groups',
  'fleet.groups.emptyDesc': 'Create a first group to organize your devices.',
  'fleet.groups.devices': '{count} device(s)',
  'fleet.groups.view': 'View devices of {name}',
  'fleet.groups.addChild': 'Add a subgroup to {name}',
  'fleet.groups.edit': 'Rename or move {name}',
  'fleet.groups.delete': 'Delete {name}',
  'fleet.groups.collapse': 'Collapse {name}',
  'fleet.groups.expand': 'Expand {name}',
  'fleet.groups.createTitle': 'New group',
  'fleet.groups.editTitle': 'Edit group',
  'fleet.groups.name': 'Name',
  'fleet.groups.nameRequired': 'The name is required.',
  'fleet.groups.description': 'Description',
  'fleet.groups.parent': 'Parent group',
  'fleet.groups.root': 'None (root)',
  'fleet.groups.created': 'Group created',
  'fleet.groups.updated': 'Group updated',
  'fleet.groups.deleted': 'Group deleted',
  'fleet.groups.deleteTitle': 'Delete group "{name}"?',
  'fleet.groups.deleteDesc': '{devices} device(s) will be detached from the group and {children} subgroup(s) will move up one level. Devices are not deleted.',
  'fleet.groups.deleteConfirm': 'Delete group',

  'fleet.alerts.thresholds': 'Alert thresholds',
  'fleet.alerts.thresholdsDesc': 'An alert is raised when a device goes past these values.',
  'fleet.alerts.disk': 'Disk used (%)',
  'fleet.alerts.ram': 'Memory used (%)',
  'fleet.alerts.offline': 'Offline for (days)',
  'fleet.alerts.pctHint': 'Alert from this percentage.',
  'fleet.alerts.offlineHint': 'Alert beyond this number of days.',
  'fleet.alerts.aiCredits': 'AI credit alerts',
  'fleet.alerts.aiCreditsHint': 'Alert at 80% and then 100% of the monthly AI credit allowance (“ai_credits.alert” webhooks and audit log).',
  'fleet.alerts.range': 'Enter a whole number between {min} and {max}.',
  'fleet.alerts.reset': 'Default values',
  'fleet.alerts.saved': 'Thresholds saved',
  'fleet.alerts.readOnly': 'You are not allowed to change the thresholds.',
  'fleet.alerts.table': 'Open alerts',
  'fleet.alerts.severity': 'Severity',
  'fleet.alerts.device': 'Device',
  'fleet.alerts.kind': 'Type',
  'fleet.alerts.raised': 'Raised',
  'fleet.alerts.allKinds': 'All types',
  'fleet.alerts.allSeverities': 'All severities',
  'fleet.kind.offline': 'Offline',
  'fleet.kind.disk': 'Disk',
  'fleet.kind.ram': 'Memory',
  'fleet.kind.agent_outdated': 'Outdated agent',
  'fleet.kind.policy_denied': 'Access denied',

  'fleet.detail.back': 'Back to fleet',
  'fleet.detail.notFound': 'Device not found',
  'fleet.detail.notFoundDesc': 'This device does not exist or does not belong to this organization.',
  'fleet.detail.rename': 'Rename',
  'fleet.detail.renameTitle': 'Rename the device',
  'fleet.detail.renamed': 'Device renamed',
  'fleet.detail.updateAgent': 'Update agent',
  'fleet.detail.updateDone': 'Agent update requested',
  'fleet.detail.revoke': 'Revoke',
  'fleet.detail.revokeTitle': 'Revoke "{name}"?',
  'fleet.detail.revoked': 'Device revoked',
  'fleet.detail.identity': 'Identity',
  'fleet.detail.sirajId': 'Siraj ID',
  'fleet.detail.hostname': 'Hostname',
  'fleet.detail.ip': 'IP address',
  'fleet.detail.enrolled': 'Enrolled on',
  'fleet.detail.groupSaved': 'Group updated',
  'fleet.detail.tagsSaved': 'Tags updated',
  'fleet.detail.noTags': 'No tags',
  'fleet.detail.addTag': 'Add a tag',
  'fleet.detail.addTagBtn': 'Add',
  'fleet.detail.removeTag': 'Remove tag {tag}',
  'fleet.detail.system': 'System and presence',
  'fleet.detail.live': 'Real time',
  'fleet.detail.channel': 'Update channel',
  'fleet.detail.outdated': 'Update available',
  'fleet.detail.upToDate': 'Up to date',
  'fleet.detail.inventory': 'Inventory',
  'fleet.detail.inventoryDesc': 'Hardware, usage and installed software',
  'fleet.detail.cpu': 'Processor',
  'fleet.detail.ram': 'Memory',
  'fleet.detail.disk': 'Disk',
  'fleet.detail.gb': 'GB',
  'fleet.detail.antivirus': 'Antivirus',
  'fleet.detail.antivirus.protected': 'Protected',
  'fleet.detail.antivirus.unprotected': 'Unprotected',
  'fleet.detail.antivirus.unknown': 'Unknown',
  'fleet.detail.diskUsage': 'Disk usage',
  'fleet.detail.ramUsage': 'Memory usage',
  'fleet.detail.threshold': 'threshold at {value}%',
  'fleet.detail.software': 'Installed software',
  'fleet.detail.softwareName': 'Software',
  'fleet.detail.softwareVersion': 'Version',
  'fleet.detail.alerts': 'Device alerts',
  'fleet.detail.alertsDesc': 'Thresholds: disk {disk}%, memory {ram}%, offline {days} d',
  'fleet.detail.noAlerts': 'No alerts on this device',
  'fleet.detail.sessions': 'Session history',
  'fleet.detail.sessionsDesc': 'Latest remote sessions on this device',
  'fleet.detail.noSessions': 'No recorded session',
  'fleet.detail.technician': 'Technician',
  'fleet.detail.duration': 'Duration',
  'fleet.detail.mode': 'Mode',
  'fleet.session.mode.attended': 'With the client',
  'fleet.session.mode.unattended': 'Unattended',
  'fleet.session.status.active': 'In progress',
  'fleet.session.status.ended': 'Ended',
  'fleet.session.status.failed': 'Failed',
};

export const fleetAr: Record<FleetKey, string> = {
  'fleet.title': 'أسطول الأجهزة',
  'fleet.description': 'أجهزة المؤسسة وحالة الاتصال والمجموعات والجرد والتنبيهات.',
  'fleet.tabs': 'أقسام الأسطول',
  'fleet.tab.devices': 'الأجهزة',
  'fleet.tab.groups': 'المجموعات',
  'fleet.tab.alerts': 'التنبيهات',
  'fleet.cancel': 'إلغاء',
  'fleet.save': 'حفظ',
  'fleet.now': 'الآن',
  'fleet.toast.error': 'فشل الإجراء. حاول مرة أخرى.',
  'fleet.summary': '{online} متصل من أصل {total} جهاز',
  'fleet.search': 'ابحث عن جهاز أو معرّف أو عنوان IP أو وسم',
  'fleet.filters': 'عوامل التصفية',
  'fleet.table': 'قائمة الأجهزة',
  'fleet.filter.status': 'الحالة',
  'fleet.filter.allStatus': 'الكل',
  'fleet.filter.os': 'النظام',
  'fleet.filter.allOs': 'الكل',
  'fleet.filter.group': 'المجموعة',
  'fleet.filter.allGroups': 'الكل',
  'fleet.filter.tag': 'الوسم',
  'fleet.filter.allTags': 'الكل',
  'fleet.empty.title': 'لا توجد أجهزة مسجّلة',
  'fleet.empty.desc': 'انشر وكيل سراج برمز التسجيل لتظهر أجهزتك هنا.',
  'fleet.empty.filtered': 'لا يوجد جهاز مطابق',
  'fleet.empty.filteredDesc': 'غيّر عوامل التصفية أو امسحها لتوسيع البحث.',
  'fleet.col.name': 'الجهاز',
  'fleet.col.status': 'الحالة',
  'fleet.col.os': 'النظام',
  'fleet.col.group': 'المجموعة',
  'fleet.col.tags': 'الوسوم',
  'fleet.col.agent': 'الوكيل',
  'fleet.col.lastSeen': 'آخر نشاط',
  'fleet.col.alerts': 'التنبيهات',

  'fleet.os.windows': 'Windows',
  'fleet.os.macos': 'macOS',
  'fleet.os.linux': 'Linux',
  'fleet.os.android': 'Android',
  'fleet.os.ios': 'iOS',

  'fleet.bulk.toolbar': 'إجراءات جماعية',
  'fleet.bulk.move': 'نقل إلى مجموعة',
  'fleet.bulk.tag': 'وسم',
  'fleet.bulk.revoke': 'إبطال',
  'fleet.bulk.clear': 'إلغاء التحديد',
  'fleet.bulk.noGroup': 'بدون مجموعة',
  'fleet.bulk.moveTitle': 'نقل {count} جهاز',
  'fleet.bulk.moveConfirm': 'نقل',
  'fleet.bulk.tagTitle': 'وسم {count} جهاز',
  'fleet.bulk.tagMode': 'العملية',
  'fleet.bulk.tagAdd': 'إضافة الوسم',
  'fleet.bulk.tagRemove': 'إزالة الوسم',
  'fleet.bulk.tagName': 'اسم الوسم',
  'fleet.bulk.tagConfirm': 'تطبيق',
  'fleet.bulk.revokeTitle': 'إبطال {count} جهاز؟',
  'fleet.bulk.revokeDesc': 'تُحذف الأجهزة المُبطلة من المؤسسة: تفقد كل وصول وتحتاج إلى تسجيل جديد. يتم تسجيل هذا الإجراء في السجل.',
  'fleet.bulk.revokeConfirm': 'إبطال',
  'fleet.bulk.done': 'تم تحديث {count} جهاز',
  'fleet.bulk.partial': 'تم تحديث {ok} جهاز وفشل {failed}',

  'fleet.groups.intro': 'نظّم الأجهزة في مجموعات متداخلة لتطبيق السياسات والصلاحيات.',
  'fleet.groups.create': 'مجموعة جديدة',
  'fleet.groups.tree': 'شجرة المجموعات',
  'fleet.groups.empty': 'لا توجد مجموعات',
  'fleet.groups.emptyDesc': 'أنشئ أول مجموعة لتصنيف أجهزتك.',
  'fleet.groups.devices': '{count} جهاز',
  'fleet.groups.view': 'عرض أجهزة {name}',
  'fleet.groups.addChild': 'إضافة مجموعة فرعية إلى {name}',
  'fleet.groups.edit': 'إعادة تسمية {name} أو نقلها',
  'fleet.groups.delete': 'حذف {name}',
  'fleet.groups.collapse': 'طي {name}',
  'fleet.groups.expand': 'توسيع {name}',
  'fleet.groups.createTitle': 'مجموعة جديدة',
  'fleet.groups.editTitle': 'تعديل المجموعة',
  'fleet.groups.name': 'الاسم',
  'fleet.groups.nameRequired': 'الاسم مطلوب.',
  'fleet.groups.description': 'الوصف',
  'fleet.groups.parent': 'المجموعة الأم',
  'fleet.groups.root': 'لا شيء (الجذر)',
  'fleet.groups.created': 'تم إنشاء المجموعة',
  'fleet.groups.updated': 'تم تعديل المجموعة',
  'fleet.groups.deleted': 'تم حذف المجموعة',
  'fleet.groups.deleteTitle': 'حذف المجموعة «{name}»؟',
  'fleet.groups.deleteDesc': 'سيتم فصل {devices} جهاز عن المجموعة وسترتفع {children} مجموعة فرعية مستوى واحدًا. لا تُحذف الأجهزة.',
  'fleet.groups.deleteConfirm': 'حذف المجموعة',

  'fleet.alerts.thresholds': 'حدود التنبيه',
  'fleet.alerts.thresholdsDesc': 'يُطلق تنبيه عندما يتجاوز الجهاز هذه القيم.',
  'fleet.alerts.disk': 'القرص المستخدم (%)',
  'fleet.alerts.ram': 'الذاكرة المستخدمة (%)',
  'fleet.alerts.offline': 'غير متصل منذ (أيام)',
  'fleet.alerts.pctHint': 'تنبيه ابتداءً من هذه النسبة.',
  'fleet.alerts.offlineHint': 'تنبيه بعد تجاوز هذا العدد من الأيام.',
  'fleet.alerts.aiCredits': 'تنبيهات رصيد الذكاء الاصطناعي',
  'fleet.alerts.aiCreditsHint': 'تنبيه عند 80٪ ثم 100٪ من الرصيد الشهري للذكاء الاصطناعي (خطافات « ai_credits.alert » وسجل التدقيق).',
  'fleet.alerts.range': 'أدخل عددًا صحيحًا بين {min} و{max}.',
  'fleet.alerts.reset': 'القيم الافتراضية',
  'fleet.alerts.saved': 'تم حفظ الحدود',
  'fleet.alerts.readOnly': 'ليست لديك صلاحية تعديل الحدود.',
  'fleet.alerts.table': 'التنبيهات المفتوحة',
  'fleet.alerts.severity': 'الخطورة',
  'fleet.alerts.device': 'الجهاز',
  'fleet.alerts.kind': 'النوع',
  'fleet.alerts.raised': 'وقت الإطلاق',
  'fleet.alerts.allKinds': 'كل الأنواع',
  'fleet.alerts.allSeverities': 'كل درجات الخطورة',
  'fleet.kind.offline': 'غير متصل',
  'fleet.kind.disk': 'القرص',
  'fleet.kind.ram': 'الذاكرة',
  'fleet.kind.agent_outdated': 'وكيل قديم',
  'fleet.kind.policy_denied': 'وصول مرفوض',

  'fleet.detail.back': 'العودة إلى الأسطول',
  'fleet.detail.notFound': 'الجهاز غير موجود',
  'fleet.detail.notFoundDesc': 'هذا الجهاز غير موجود أو لا ينتمي إلى هذه المؤسسة.',
  'fleet.detail.rename': 'إعادة تسمية',
  'fleet.detail.renameTitle': 'إعادة تسمية الجهاز',
  'fleet.detail.renamed': 'تمت إعادة تسمية الجهاز',
  'fleet.detail.updateAgent': 'تحديث الوكيل',
  'fleet.detail.updateDone': 'تم طلب تحديث الوكيل',
  'fleet.detail.revoke': 'إبطال',
  'fleet.detail.revokeTitle': 'إبطال «{name}»؟',
  'fleet.detail.revoked': 'تم إبطال الجهاز',
  'fleet.detail.identity': 'الهوية',
  'fleet.detail.sirajId': 'معرّف سراج',
  'fleet.detail.hostname': 'اسم المضيف',
  'fleet.detail.ip': 'عنوان IP',
  'fleet.detail.enrolled': 'تاريخ التسجيل',
  'fleet.detail.groupSaved': 'تم تحديث المجموعة',
  'fleet.detail.tagsSaved': 'تم تحديث الوسوم',
  'fleet.detail.noTags': 'لا وسوم',
  'fleet.detail.addTag': 'إضافة وسم',
  'fleet.detail.addTagBtn': 'إضافة',
  'fleet.detail.removeTag': 'إزالة الوسم {tag}',
  'fleet.detail.system': 'النظام والحضور',
  'fleet.detail.live': 'الوقت الفعلي',
  'fleet.detail.channel': 'قناة التحديث',
  'fleet.detail.outdated': 'تحديث متاح',
  'fleet.detail.upToDate': 'محدَّث',
  'fleet.detail.inventory': 'الجرد',
  'fleet.detail.inventoryDesc': 'العتاد والاستخدام والبرامج المثبتة',
  'fleet.detail.cpu': 'المعالج',
  'fleet.detail.ram': 'الذاكرة',
  'fleet.detail.disk': 'القرص',
  'fleet.detail.gb': 'غ.ب',
  'fleet.detail.antivirus': 'مضاد الفيروسات',
  'fleet.detail.antivirus.protected': 'محمي',
  'fleet.detail.antivirus.unprotected': 'غير محمي',
  'fleet.detail.antivirus.unknown': 'غير معروف',
  'fleet.detail.diskUsage': 'استخدام القرص',
  'fleet.detail.ramUsage': 'استخدام الذاكرة',
  'fleet.detail.threshold': 'الحد عند {value}%',
  'fleet.detail.software': 'البرامج المثبتة',
  'fleet.detail.softwareName': 'البرنامج',
  'fleet.detail.softwareVersion': 'الإصدار',
  'fleet.detail.alerts': 'تنبيهات الجهاز',
  'fleet.detail.alertsDesc': 'الحدود: القرص {disk}%، الذاكرة {ram}%، غير متصل {days} يوم',
  'fleet.detail.noAlerts': 'لا توجد تنبيهات على هذا الجهاز',
  'fleet.detail.sessions': 'سجل الجلسات',
  'fleet.detail.sessionsDesc': 'آخر الجلسات عن بُعد على هذا الجهاز',
  'fleet.detail.noSessions': 'لا توجد جلسات مسجلة',
  'fleet.detail.technician': 'التقني',
  'fleet.detail.duration': 'المدة',
  'fleet.detail.mode': 'النمط',
  'fleet.session.mode.attended': 'بحضور العميل',
  'fleet.session.mode.unattended': 'دون مراقبة',
  'fleet.session.status.active': 'جارية',
  'fleet.session.status.ended': 'منتهية',
  'fleet.session.status.failed': 'فاشلة',
};
